import PolicyLayout from "@/components/PolicyLayout";

function Section({ title, children }) {
  return (
    <div className="mb-10">
      <h2 className="font-heading text-xl sm:text-2xl tracking-tight font-medium mb-4">{title}</h2>
      {children}
    </div>
  );
}

function P({ children }) {
  return <p className="text-base leading-relaxed text-muted-foreground mb-3">{children}</p>;
}

function List({ items }) {
  return (
    <ul className="space-y-2 mb-4">
      {items.map((item, i) => (
        <li key={i} className="flex items-start gap-3 text-base leading-relaxed text-muted-foreground">
          <span className="w-1.5 h-1.5 rounded-full bg-[hsl(var(--accent))] mt-2 flex-shrink-0" />
          {item}
        </li>
      ))}
    </ul>
  );
}

export default function TermsPage() {
  return (
    <PolicyLayout title="Terms & Conditions" subtitle="Legal">
      <P>
        <em className="text-sm text-muted-foreground">Last updated: {new Date().toLocaleDateString('en-IN', { month: 'long', year: 'numeric' })}</em>
      </P>

      <Section title="1. About Cita Rush">
        <P>
          Cita Rush organizes curated offline dating and social events at cafes, restaurants, bars, and
          partner venues in Pune and other cities as launched. By registering for or attending any Cita Rush event,
          you agree to these Terms & Conditions.
        </P>
      </Section>

      <Section title="2. Eligibility">
        <List items={[
          "Users must be 18 years of age or older to register or attend any Cita Rush event.",
          "Entry is subject to eligibility, seat availability, venue rules, and organizer approval.",
          "Cita Rush reserves the right to deny registration or entry at its sole discretion.",
        ]} />
      </Section>

      <Section title="3. Registration & Pricing">
        <List items={[
          "Men may be charged a booking fee (currently ₹1,399 per event); women may have free or waitlist-based registration depending on event format.",
          "A ticket or registration gives access to the curated event experience — the venue, hosts, games, and mini-dates. It does not guarantee a romantic match.",
          "Matches are based solely on mutual selections between participants.",
        ]} />
      </Section>

      <Section title="4. No-Match Policy">
        <P>
          If a participant receives zero mutual matches after attending an event, Cita Rush may, at its discretion,
          issue a one-time discount or credit toward a future event. No cash refund is guaranteed.
        </P>
      </Section>

      <Section title="5. Refunds & Transfers">
        <List items={[
          "Tickets are non-refundable and non-transferable except where Cita Rush cancels or significantly reschedules the event.",
          "In the event of cancellation by Cita Rush, participants may receive a transfer to another event, a reschedule option, or credit as determined by the organizer.",
        ]} />
      </Section>

      <Section title="6. Event Changes">
        <P>
          Cita Rush may change venue, schedule, age band, event format, or host due to operational reasons.
          Participants will be notified of significant changes where possible.
        </P>
      </Section>

      <Section title="7. Conduct & Safety">
        <List items={[
          "Misconduct, harassment, intoxicated disruption, fake identity, or safety violations may lead to immediate removal without refund.",
          "Cita Rush enforces a strict Code of Conduct at all events. All participants are expected to treat others with respect.",
          "Cita Rush is not responsible for personal interactions, dates, or outcomes after the event.",
        ]} />
      </Section>

      <Section title="8. User Responsibilities">
        <P>
          Users are responsible for their own conduct, transport, and personal safety before, during, and after
          events. Cita Rush provides a curated social environment but does not assume liability for individual
          actions or outcomes.
        </P>
      </Section>

      <Section title="9. Governing Law">
        <P>
          These Terms & Conditions shall be governed by and construed in accordance with the laws of India.
          Any disputes shall be subject to the exclusive jurisdiction of the courts in Pune, Maharashtra.
        </P>
      </Section>

      <Section title="10. Contact">
        <P>
          For questions about these Terms, please contact us at{" "}
          <span className="text-foreground font-medium">legal@citarush.com</span>.
        </P>
      </Section>
    </PolicyLayout>
  );
}
